/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'
import { tItem } from 'src/shared/frontendTypes/wunschliste'

const Redux = () => {
  const dispatch = useDispatch()

  const items = useSelector(store => store.Wunschliste.items)

  const addItem = (item: tItem) =>
    dispatch({ type: 'addWunschlisteItem', payload: item })

  const removeItem = (key:string) =>
    dispatch({ type: 'removeWunschlisteItem', payload: key })

  return { items, addItem, removeItem }
}

export default Redux
